import { BaseModel, CountryModel, StateModel } from "@insite/client-framework/Types/ApiModels";

export interface ShipToModel extends BaseModel {
    state: StateModel | null;
}

interface AddressModel extends BaseModel {
    address1: string;
    address2: string;
    address3: string;
    address4: string;
    city: string;
    country: CountryModel | null;
    postalCode: string;
    state: StateModel | null;
}

export function wipeAddressFields<T extends AddressModel>(currentModel: T, countrySelected: CountryModel | null): T {
    return {
        ...currentModel,
        address1: '',
        address2: '',
        address3: '',
        address4: '',
        city: '',
        country: countrySelected,
        postalCode: '',
        state: null,
    };
}
